import React, { useRef, useState, useEffect } from 'react';
import Select from 'react-select';
import AsyncPaginateSelect from './AsyncPaginateSelect';


const TaxonomyLimitsForm = ({
    isNew=true,
    defaultModel=null,
    defaultModelIds=[],
    modelsList=[],
    modelsListOptions={},
    modelField="",
    modelIdsField="",
}) => {


    console.log( defaultModelIds )

    const [currentModel, setCurrentModel] = useState(defaultModel)
    const modelsListOptionsRef = useRef(null)

    var modelIdsFieldInput = document.getElementById(modelIdsField)
    modelIdsFieldInput.value = (!defaultModelIds.length)? "[]":JSON.stringify(defaultModelIds.map((v => v['value'])))


    return (
        <>
            <div className="field">
                <div className="px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <div className="text-sm font-medium text-gray-500">      
                        <div>     
                            <span className="p-2 flex-1 w-0 break-all w-full ">Model</span>
                        </div>
                    </div>
                    <div className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                        {
                        (isNew)?
                            <Select
                                defaultValue={{"label": currentModel, "value": currentModel}}
                                isMulti={false}
                                options={modelsList}
                                onChange={(val) => {
                                    setCurrentModel(val.value)
                                    modelsListOptionsRef.current.state.value = []

                                    var modelfieldInput = document.getElementById(modelField)
                                    modelfieldInput.value = val.value
                                }}
                            />
                            :
                            <span>{currentModel}</span>
                        }
                    </div>
                </div>
            </div>
            <div className="field">
                <div className="px-4 py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                    <div className="text-sm font-medium text-gray-500">      
                        <div>     
                            <span className="p-2 flex-1 w-0 break-all w-full ">Ids</span>
                        </div>
                    </div>
                    <div className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                        <AsyncPaginateSelect 
                            modelOptionsRef={modelsListOptionsRef}    
                            currentModel={currentModel}
                            modelIdsField={modelIdsField}
                            defaultModelIds={defaultModelIds}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default TaxonomyLimitsForm;